import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=6c72a164&scoped=true&"
import script from "./Marketplace.vue?vue&type=script&lang=ts&"
export * from "./Marketplace.vue?vue&type=script&lang=ts&"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=6c72a164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c72a164",
  null
  
)

export default component.exports